import { useEffect, useState } from 'react';
export const useEditorToolbarChangeDetector = ButtonWrapper => {
  const [toolbarMutationCount, setToolbarMutationCount] = useState(0);
  useEffect(() => {
    if (!ButtonWrapper) {
      return;
    }
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        const {
          addedNodes,
          removedNodes
        } = mutation;
        const isRelevantMutation = [...addedNodes, ...removedNodes].some(node => node.nodeType === 1 && node.nodeName === 'DIV');
        if (isRelevantMutation) {
          setToolbarMutationCount(toolbarMutationCount + 1);
        }
      });
    });
    const mainToolBar = document.querySelector(`[data-testid="ak-editor-main-toolbar"]`);
    if (mainToolBar) {
      observer.observe(mainToolBar, {
        childList: true,
        subtree: true
      });
    }
    return () => {
      observer.disconnect();
    };
  }, [toolbarMutationCount, ButtonWrapper]);
  return toolbarMutationCount;
};